import { type CsticId } from "~/features/configurator/Linear/models";
import { useCsticInputProps } from "~/features/configurator/Shaft/components/useCsticInputProps";
import { type SubstepType } from "~/features/configurator/Linear/dtos";
import LanguageAwareExternalContent from "~/features/configurator/Linear/components/LanguageAwareExternalContent";
import { TextField } from "~/common/mui";

interface Props {
  className?: string;
  csticId: CsticId;
  substepType: SubstepType;
  label?: string;
  helperLabel?: string;
  disabled?: boolean;
  csticsToNull?: string[];
  csticsToSet?: Array<CsticToSet | Resolver>;
}

type CsticToSet =
  | {
      key: string;
      value: string;
    }
  | undefined;

type Resolver = (value: string | null) => CsticToSet;

export const SimpleCsticTextField = ({
  className,
  csticId,
  substepType,
  label,
  csticsToNull,
  csticsToSet,
  helperLabel,
  disabled,
}: Props) => {
  const inputProps = useCsticInputProps({
    csticId,
    substep: substepType,
    csticsToNull,
    csticsToSet,
    type: "string",
  });

  return (
    <TextField
      fullWidth
      className={className}
      label={
        label ? <LanguageAwareExternalContent content={label} className={"scha__lc__external-label"} /> : undefined
      }
      helperText={helperLabel}
      disabled={disabled}
      {...inputProps}
      onChange={(e) => inputProps.onChange(e.target.value)}
    />
  );
};
